import { Dropdown } from 'antd';
import { Link } from 'react-router-dom';

const SiderMenuItemWithAction = ({ to, title, menu }) => {
  return (
    <Link className="item-with-action" to={to}>
      <span>{title}</span>
      <Dropdown menu={{ items: menu }}>
        <span className="circle plus" />
      </Dropdown>
    </Link>
  );
};

export default SiderMenuItemWithAction;
